function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.48 10.77l-3.79 5.05H6.08c-.96 0-1.44-1.16-.76-1.84L10.5 8.8a2.13 2.13 0 013.01 0l1.97 1.97z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.92 15.82h-6.23l3.79-5.05 3.21 3.21c.67.68.19 1.84-.77 1.84z"
})));